<div *ngIf="shipmentId">
    <div class="title">{{'SHIPMENTCMR.EVENT.LIST.TITLE'| translate}}</div>
  
    <div class="block info">
        <shared-cmr-events-list [events]="getListEvents()">
        </shared-cmr-events-list>
    </div>
    
</div>
